import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {select} from './connectors';
import queryString from 'query-string';

import './index.scss';

const propTypes = {
  productKey: PropTypes.string.isRequired,
  saveResponse: PropTypes.object
};

/** @extends {Component<PropTypes.InferProps<typeof propTypes>>} */
export class TrackingPixel extends Component {
  static displayName = 'TrackingPixel';
  static propTypes = propTypes;

  renderParameterString() {
    var designData = this.props.saveResponse.design;
    var params = {
      mid: 'customink',
      oid: 'design-' + designData.designid,
      lid: 1,
      cid: designData.account_id,
      iid: this.props.productKey.toString(),
      icent: 0,
      iqty: 0,
      iname: 'Gildan Ultra Cotton T-shirt'
    };
    while (params.iid.length < 5) {
      params.iid = '0' + params.iid;
    }
    if (designData.first_time_saving) {
      params.cid += '|0|';
    } else {
      params.cid += '|1|';
    }
    return queryString.stringify(params);
  }

  render() {
    if (this.props.saveResponse && this.props.saveResponse.success) {
      return (
        <div className="ndx-Content-app-trackingPixel">
          <img
            src={
              'http://www.rkdms.com/order.gif?' + this.renderParameterString()
            }
          />
        </div>
      );
    } else {
      return null;
    }
  }
}

export default connect(state => select(state))(TrackingPixel);
